'use client';

import { forwardRef } from 'react';
import clsx from 'clsx';
import DallasText from '@ui/Dallas/Text/DallasText';
import DallasSvgIcon from '@ui/Dallas/Icons/DallasSvgIcon';
import styles from './NavItem.module.scss';

export interface Props {
  icon?: React.ReactElement<typeof DallasSvgIcon>;
  onClick: () => void;
  label: string;
  withBrandBadge?: boolean;
}

const NavButton = forwardRef<HTMLButtonElement, Props>(function NavButton(
  { onClick, icon, label, withBrandBadge = false }: Props,
  ref,
) {
  return (
    <button
      ref={ref}
      className={clsx(styles.root, withBrandBadge && styles.withBrandBadge)}
      type="button"
      onClick={onClick}
    >
      {icon ?? <div className={styles.iconPlaceholder}></div>}
      <DallasText className={styles.label} align="start">
        {label}
      </DallasText>
    </button>
  );
});

export default NavButton;
